import React from 'react';
import { observer } from 'mobx-react';
import { NoteTableRowTemplate } from 'themes/application/pumps/components';

@observer
class NoteTableRow extends React.Component {
    render() {
        return (
            <NoteTableRowTemplate {...this.props}/>
        );
    }
}

export default NoteTableRow;